// 🆕 19.10.2026 · Auftrag 58, R4: Anker-Prüfliste beim Setzen der Anker (Hinweise, nie Sperre).
// Nur hinter REACT_APP_BODENKLICK_STRECKE=1 eingehängt (Wizard.jsx, unter dem Anker-Sammelmodus). Lädt neu, wenn sich
// `stand` ändert (der Wizard zählt ihn bei jeder Anker-Änderung hoch). Regeln im Backend (routes/bodenklicks.py).
import React, { useEffect, useState } from "react";
import { getAnkerPruefliste } from "@/lib/api";
import { ankerZeile, nurMitHinweis, zusammenfassungText } from "@/lib/bodenklicks";

export default function AnkerPruefliste({ sequenceId, stand }) {
  const [daten, setDaten] = useState(null);
  const [fehler, setFehler] = useState(null);
  const [nurHinweise, setNurHinweise] = useState(false);

  useEffect(() => {
    let aktiv = true;
    getAnkerPruefliste(sequenceId)
      .then((d) => { if (aktiv) { setDaten(d); setFehler(null); } })
      .catch(() => { if (aktiv) setFehler("Prüfliste nicht ladbar"); });
    return () => { aktiv = false; };
  }, [sequenceId, stand]);

  if (fehler) return <div className="font-mono text-[11px] text-red-300">{fehler}</div>;
  if (!daten) return <div className="font-mono text-[11px] text-muted-foreground">Prüfliste lädt …</div>;
  const liste = nurMitHinweis(daten.anker, nurHinweise);

  return (
    <div data-testid="anker-pruefliste" className="border border-border rounded-md p-3 space-y-2 font-mono text-[11px]">
      <div className="flex flex-wrap items-center gap-3">
        <span className="uppercase tracking-widest text-muted-foreground">Anker-Prüfliste</span>
        <span data-testid="anker-pruefliste-zusammenfassung">{zusammenfassungText(daten.zusammenfassung)}</span>
        <label className="flex items-center gap-1">
          <input type="checkbox" checked={nurHinweise} onChange={(e) => setNurHinweise(e.target.checked)} />
          nur mit Hinweis
        </label>
      </div>
      {daten.hinweis_video && (
        <div data-testid="anker-pruefliste-hinweis-video" className="text-amber-300">{daten.hinweis_video}</div>
      )}
      <div className="max-h-64 overflow-y-auto space-y-1">
        {liste.map((a) => (
          <div key={a.anker_id} className={a.hinweise.length ? "text-amber-300" : ""}>
            {ankerZeile(a)}
            {a.hinweise.length > 0 && <span> — {a.hinweise.join(" · ")}</span>}
          </div>
        ))}
        {liste.length === 0 && <div className="text-muted-foreground">Keine Anker{nurHinweise ? " mit Hinweis" : ""}.</div>}
      </div>
    </div>
  );
}
